var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9478 3.38957V4.51942H19.2075C21.0796 4.51942 22.5971 6.03699 22.5971 7.90899V19.2075C22.5971 21.0796 21.0796 22.5971 19.2075 22.5971H3.38957C1.51757 22.5971 0 21.0796 0 19.2075V7.90899C0 6.03699 1.51757 4.51942 3.38957 4.51942H5.64928V3.38957C5.64928 1.51757 7.16684 0 9.03884 0H13.5583C15.4303 0 16.9478 1.51757 16.9478 3.38957ZM14.6881 4.51942H7.90899V3.38957C7.90899 2.76557 8.41485 2.25971 9.03884 2.25971H13.5583C14.1823 2.25971 14.6881 2.76557 14.6881 3.38957V4.51942ZM7.90899 12.4284H2.25971V19.2075C2.25971 19.8316 2.76557 20.3374 3.38957 20.3374H19.2075C19.8316 20.3374 20.3374 19.8316 20.3374 19.2075V12.4284H14.6881V13.5583C14.6881 14.1823 14.1823 14.6881 13.5583 14.6881H9.03884C8.41485 14.6881 7.90899 14.1823 7.90899 13.5583V12.4284Z",
    fill: "#1865C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBag);
export default __webpack_public_path__ + "static/media/blue_bag.a4d0c1b801d3e7d8503b3325e5599d69.svg";
export { ForwardRef as ReactComponent };